import Footer from "../COMPONENTS/FOOTER";
import NavBar from "../COMPONENTS/NAVBAR";
import "./index.css";

const Layout = ({ children }) => {
  return (
    <div>
      <NavBar className="navbar" />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
